import { Box, BoxProps, Flex, Heading, Text, Textarea } from '@chakra-ui/react'
import React from 'react'

export interface ItensTabelaProps{
  descricaoDicionario?: Array<Record<string, string[]>>
}

export interface TabelaItensProps extends BoxProps {
  tituloTabela: string
  itensTabela?: ItensTabelaProps[]
  descricaoSimples?: string
  isTabelaDescricaoSimples?: boolean
  setMissao?: (missao: string) => void
}

export const TabelaItensEditing: React.FC<TabelaItensProps> = ({ tituloTabela, itensTabela, descricaoSimples, isTabelaDescricaoSimples, setMissao, ...rest }) => {
    type Linha = { titulo: string, itens: string[] }

    function normalizarDescricao(item: ItensTabelaProps): Linha[] {
      const d = item.descricaoDicionario ?? []
      return d.flatMap((rec) =>
        Object.entries(rec).map(([titulo, itens]) => ({
          titulo,
          itens: itens ?? []
        }))
      )
    }

    return (
        <Box pt={'4'} pb={'4'} {...rest}>
            <Flex w={'1380px'} border={'2px solid var(--chakra-colors-gray-400)'} flexDirection={'column'} >
                <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'} >
                    <Heading size={'md'}>{tituloTabela}</Heading>
                </Box>
                {!isTabelaDescricaoSimples
                  ? (
                <Box display="flex" flexDirection="column" w="100%">
                {itensTabela?.map((item, index) => {
                  const linhas = normalizarDescricao(item)

                  return (
                    <Box key={index} w="100%">
                        {linhas.map((linha, idx) => (
                        <Box
                            key={idx}
                            display="flex"
                            w="100%"
                            borderBottom="1px solid var(--chakra-colors-gray-400)"
                        >
                            {/* ESQUERDA: nível */}
                            <Box
                            w="112px"
                            bg="gray.200"
                            display="flex"
                            alignItems="center"
                            p={4}
                            flexShrink={0}
                            >
                            <Heading ml="1rem" size="md" fontWeight="normal">
                                {linha.titulo}
                            </Heading>
                            </Box>

                            {/* DIREITA: itens */}
                            <Box w="100%" bg="white" p={4}>
                            {linha.itens.filter(Boolean).map((txt, i) => (
                                <Text key={i} size="md">
                                {txt}
                                </Text>
                            ))}
                            </Box>
                        </Box>
                        ))}
                    </Box>
                  )
                })}
                </Box>
                    )
                  : (
                   <Box display="flex" flexDirection="column" w="100%">
                    <Box w="100%" bg="white" p={4}>
                              <Textarea value={descricaoSimples}
                                onChange={(e) => {
                                  if (setMissao) {
                                    setMissao(e.target.value)
                                  }
                                }} />
                            </Box>
                   </Box>
                    )}
                </Flex>
            </Box>
    )
}
